import "./style/index.scss";

import React, { Component } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import Absence from "./components/Absence";
import Birthdays from "./components/Birthdays";
import Calendars from "./components/Calendars";
import Header from "./components/Header";
import NotFound from "./components/NotFound";
import ProjectsIndicators from "./components/ProjectsIndicators";
import { Provider } from "react-redux";
import ServicesCatalog from "./components/ServicesCatalog";
import ServicesQueue from "./components/ServicesQueue";
import ThemeContainer from "./components/ThemeContainer";
import store from "./store";

// Redux

class App extends Component {
  componentDidUpdate(prevProps) {
    console.log(prevProps, this.props);
  }

  render() {
    return (
      <Provider store={store}>
        <Router>
          <ThemeContainer>
            <div className="container">
              <Header />
              <Switch>
                <Route exact path="/" component={ServicesCatalog} />
                <Route exact path="/service/:id" component={ServicesCatalog} />
                <Route exact path="/ServicesQueue" component={ServicesQueue} />
                <Route exact path="/Absence" component={Absence} />
                <Route exact path="/Absence/:id" component={Absence} />
                <Route
                  exact
                  path="/ProjectsIndicators"
                  component={ProjectsIndicators}
                />
                <Route exact path="/Birthdays" component={Birthdays} />
                <Route exact path="/Calendars" component={Calendars} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </ThemeContainer>
        </Router>
      </Provider>
    );
  }
}

export default App;
